import type { AnalyticsBrowser } from "@customerio/cdp-analytics-browser";

import {
  CUSTOMER_IO_EVENT,
  GOOGLE_TAG_MANAGER_EVENT,
  MOUSEFLOW_EVENT,
} from "@/features/analytics/models";
import {
  triggerGoogleTagManagerTracking,
  triggerMouseflowTracking,
} from "@/features/analytics/triggers";

interface TrackHealthDisqualifiedParams {
  customerIoAnalytics: AnalyticsBrowser;
}

export const trackHealthDisqualified = ({
  customerIoAnalytics,
}: TrackHealthDisqualifiedParams) => {
  triggerGoogleTagManagerTracking({
    event: GOOGLE_TAG_MANAGER_EVENT.HEALTH_DISQUALIFIED,
  });

  triggerMouseflowTracking({ event: MOUSEFLOW_EVENT.HEALTH_DISQUALIFIED });

  void customerIoAnalytics.track(CUSTOMER_IO_EVENT.HEALTH_DISQUALIFIED, {
    source: window.location.href,
  });
};
